module.exports = __webpack_public_path__ + "static/_georgianLogo-721c65fa6eafebe6d79e32e49ccb1df5.png";